// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2z9_U","selects":"Documents_selects__2_lbd"};